import validation from './../../../services/validation';

import template from './name-and-year.jade';

export default angular
  .module('cian.addForm.nameAndYear', [])
  .directive('cianAfAboutBuildingNameAndYear', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      'jkService', 'categoryService', '$scope', 'addressService', 'deviceService',
      // eslint-disable-next-line func-names
      function (
        jkService, categoryService, $scope, addressService, deviceService,
      ) {
        this.isMobile = deviceService.isMobile;

        const currentYear = new Date().getFullYear();
        this.yearMin = currentYear - 250;
        this.yearMax = currentYear + 250;
        this.ad.geo = this.ad.geo || {};

        jkService.initializeEmptyJK();

        const setJkHouse = houses => {
          const { dealType } = categoryService.getInfoByCategory(this.ad.category);

          if (Array.isArray(houses) && houses.length > 0) {
            const { isFinished, ...params } = houses[0];
            jkService.setJKByKey('house', {
              ...params,
              isFinished: dealType === 'rent' ? true : isFinished,
            });
          } else {
            jkService.setJKByKey('house', null);
          }
        };

        const setJk = jkObj => {
          if (angular.isObject(jkObj)) {
            jkService.setJKByKey('id', jkObj.id);
            jkService.setJKByKey('name', jkObj.name);
            jkService.setJkDeveloper(jkObj.developers);
            setJkHouse(jkObj.houses);

            this.ad.building.name = jkObj.name;
          } else {
            jkService.initializeEmptyJK({ force: true });
          }
        };

        this.getJks = term => {
          const results = term && term.trim().length > 2
            ? jkService.getJksWithCurrentGeo({ term })
            : [];

          if (Array.isArray(results) && !results.length) {
            jkService.initializeEmptyJK({ force: true });
          }

          return results;
        };

        const addressListener = $scope.$watch(
          () => Array.isArray(this.ad.geo.address) && this.ad.geo.address.find(item => item.type === 'house'),
          (geoObj, oldGeoObj) => {
            if (geoObj === oldGeoObj) {
              return;
            }

            if (!angular.isObject(geoObj)) {
              jkService.initializeEmptyJK({ force: true });

              return;
            }

            jkService.getJkByGeoObj(geoObj).then(jk => {
              setJk(jk);
            }).catch(() => {
              jkService.initializeEmptyJK({ force: true });
            });
          }
        );

        $scope.$on('$destroy', () => {
          addressListener();
        });

        this.onSelectJk = $item => {
          setJk($item);
        };

        this.validation = validation(this.form, 'building.buildYear', {
          parse: 'Введите число',
          min: `Укажите год позднее ${this.yearMin}`,
          max: `Укажите год ранее ${this.yearMax}`,
        });
      }],
      controllerAs: 'nameAndYear',
      template,
  }))
  .name;
